import axios from "axios";
import { ApiEndPoint } from "./apiUttiLities";
import { JwtService } from "./jwtapi";
// const API_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = ApiEndPoint;

/**
 * Authentication and common api services
 * - signup: calls backend /api/auth/signup
 * - login: calls backend /api/auth/login and stores token in localStorage
 * - logout: removes token
 * - fetchIncidents: existing helper (keeps previous behavior)
 * - getNotifications: fetch recent notifications from backend
 */
const timestamp = Date.now();


const signup = async (data) => {
    //   data.user_type ="admin"
    const url = `${API_URL}/api/auth/signup`;
    return await JwtService.commanApi(data, url, "POST", false, { publicRequest: true });
};

const login = async (data) => {
    const url = `${API_URL}/api/auth/login`;
    return await JwtService.commanApi(data, url, "POST", false, { publicRequest: true });
};

const forgotPassword = async (data) => {
    const url = `${API_URL}/api/auth/forgot-password`;
    return await JwtService.commanApi(data, url, "POST", false, { publicRequest: true });
};

const getMe = async () => {
    const url = `${API_URL}/api/auth/me`;
    return await JwtService.commanApi({}, url, "GET");
};

const updateProfile = async (data) => {
    const url = `${API_URL}/api/auth/me`;
    return await JwtService.commanApi(data, url, "PUT");
};

const changePassword = async (data) => {
    const url = `${API_URL}/api/auth/change-password`;
    return await JwtService.commanApi(data, url, "POST");
};

const impersonateUser = async (userId) => {
    const url = `${API_URL}/api/auth/impersonate/${userId}`;
    return await JwtService.commanApi({}, url, "POST");
};



const setToken = (token) => {
    if (token) {
        localStorage.setItem("access_token", token);
    }
};

const getToken = () => {
    return localStorage.getItem("access_token");
};

const logout = () => {
    JwtService.clearSession()
};

const fetchIncidents = async (data) => {
    const url = API_URL + `/api/incident-classifications`;
    return await JwtService.commanApi(data, url, "GET");
};

// New: fetch notifications list from backend
const getNotifications = async (limit = 50) => {
    const url = `${API_URL}/api/notifications`;
    return await JwtService.commanApi({}, url, "GET");
};

const postIncidentHistory = async (data) => {
    const url = `${API_URL}/api/recent-incident-history`;
    return await JwtService.commanApi(data, url, "POST");
};

const getIncidentHistory = async () => {
    const url = `${API_URL}/api/recent-incident-history`;
    return await JwtService.commanApi({}, url, "GET");
};

const deleteIncidentHistory = async (id) => {
    const url = `${API_URL}/api/recent-incident-history/${id}`;
    return await JwtService.commanApi({}, url, "DELETE");
};

const getincidentTimeline = async (id, params = '') => {
    const query = new URLSearchParams(params?.toString?.() || String(params || ''));
    query.set('include_planned', 'true');
    const url = `${API_URL}/api/incidents/${id}/timeline?${query.toString()}`;
    return await JwtService.commanApi({}, url, "GET");
};

const getIncidentPlanAdherence = async (id) => {
    const url = `${API_URL}/api/incidents/${id}/plan-adherence`;
    return await JwtService.commanApi({}, url, "GET");
};

const imagePreview = async (file_key) => {
    const url = `${API_URL}/api/image-preview/${file_key}`;
    return await JwtService.commanApi({}, url, "GET");
}

const getIncidentsData = async () => {
    const url = `${API_URL}/api/incidents?limit=1000&skip=0`;
    const response = await JwtService.commanApi({}, url, "GET");
    const visibleIncidents = (items) => (
        Array.isArray(items)
            ? items.filter((incident) => incident?.is_planned_event !== true || incident?.is_exercise === true)
            : items
    );
    if (Array.isArray(response)) return visibleIncidents(response);
    if (Array.isArray(response?.data)) {
        return { ...response, data: visibleIncidents(response.data) };
    }
    return response;
}

const incidentClassifications = async () => {
    const url = `${API_URL}/api/incident-classifications`;
    return await JwtService.commanApi({}, url, "GET");
}

const departments = async () => {
    const url = `${API_URL}/api/departments`;
    return await JwtService.commanApi({}, url, "GET");
}

const departmentslocationcounts = async () => {
    const url = `${API_URL}/api/departments/with-location-counts`;
    return await JwtService.commanApi({}, url, "GET");
}

const getIncidentDetail = async (id) => {
    const url = `${API_URL}/api/incidents/${id}?t=${Date.now()}`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationsType = async () => {
    const url = `${API_URL}/api/locations/suggestions/unified-types`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationsValue = async () => {
    const url = `${API_URL}/api/locations/suggestions/unified-values`;
    return await JwtService.commanApi({}, url, "GET");
}

const deleteLocationZones = async (locationId) => {
    const url = `${API_URL}/api/locations/zones/${locationId}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const getLocationDepartmentCounts = async (locationId) => {
    const url = `${API_URL}/api/locations/${locationId}/departments?t=${Date.now()}`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationszoneswithlinks = async () => {
    const url = `${API_URL}/api/locations/zones/with-links`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationssuggestionszonenames = async () => {
    const url = `${API_URL}/api/locations/suggestions/zone-names`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationssuggestionszonetypes = async () => {
    const url = `${API_URL}/api/locations/suggestions/zone-types`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationssuggestionsbuildings = async () => {
    const url = `${API_URL}/api/locations/suggestions/buildings`;
    return await JwtService.commanApi({}, url, "GET");
}
const locationssuggestionsfloors = async () => {
    const url = `${API_URL}/api/locations/suggestions/floors`;
    return await JwtService.commanApi({}, url, "GET");
}
const locationssuggestionscorridors = async () => {
    const url = `${API_URL}/api/locations/suggestions/corridors`;
    return await JwtService.commanApi({}, url, "GET");
}
const locationssuggestionsrooms = async () => {
    const url = `${API_URL}/api/locations/suggestions/rooms`;
    return await JwtService.commanApi({}, url, "GET");
}

const deletelocationssuggestionszonetypes = async (id) => {
    const url = `${API_URL}/api/locations/suggestions/zone-types/${encodeURIComponent(id)}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const deletelocationssuggestionsbuildings = async (id) => {
    const url = `${API_URL}/api/locations/suggestions/buildings/${encodeURIComponent(id)}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const deletelocationssuggestionsfloors = async (id) => {
    const url = `${API_URL}/api/locations/suggestions/floors/${encodeURIComponent(id)}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const deletelocationssuggestionscorridors = async (id) => {
    const url = `${API_URL}/api/locations/suggestions/corridors/${encodeURIComponent(id)}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const deletelocationssuggestionsrooms = async (id) => {
    const url = `${API_URL}/api/locations/suggestions/rooms/${encodeURIComponent(id)}`;
    return await JwtService.commanApi({}, url, "DELETE");
}
const updatelocationshierarchy = async (data, id) => {
    const url = `${API_URL}/api/locations/hierarchy/${id}`;
    // Send as multipart/form-data when 'data' is a FormData instance (files included)
    return await JwtService.commanApi(data, url, "PUT", true);
}
const setlocationshierarchy = async (data) => {
    const url = `${API_URL}/api/locations/hierarchy`;
    return await JwtService.commanApi(data, url, "POST", true);
}

const addDepartmentToLocation = async (id, lo_id) => {
    const url = `${API_URL}/api/departments/${id}/locations/${lo_id}`;
    return await JwtService.commanApi({}, url, "POST");
}

const deleteDepartmentToLocation = async (id, lo_id) => {
    const url = `${API_URL}/api/departments/${id}/locations/${lo_id}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const getbyIddepartments = async (id) => {
    const url = `${API_URL}/api/departments/${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const updatedepartments = async (id, data) => {
    const url = `${API_URL}/api/departments/${id}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const locationshierarchyByid = async (id) => {
    const url = `${API_URL}/api/locations/hierarchy/${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const locationszonesChipId = async (id) => {
    const url = `${API_URL}/api/locations/zones/${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const updatelocationszones = async (id, data) => {
    const url = `${API_URL}/api/locations/zones/${id}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const getdepartmentssuggestionsmembers = async (id) => {
    const url = `${API_URL}/api/departments/suggestions/members`;
    return await JwtService.commanApi({}, url, "GET");
}

const getuserconfigs = async (id) => {
    const url = `${API_URL}/api/user-configs`;
    return await JwtService.commanApi({}, url, "GET");
}

const updateuserconfigs = async (id, data) => {
    const url = `${API_URL}/api/user-configs/${id}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const adddepartments = async (data) => {
    const url = `${API_URL}/api/departments`;
    return await JwtService.commanApi(data, url, "POST");
}

const deletebyIddepartments = async (id) => {
    const url = `${API_URL}/api/departments/${id}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const getdepartmentslocation = async (id) => {
    const url = `${API_URL}/api/departments/${id}/locations`;
    return await JwtService.commanApi({}, url, "GET");
}

const getlocationszonesdata = async () => {
    const url = `${API_URL}/api/locations/zones`;
    return await JwtService.commanApi({}, url, "GET");
}

const getuserconfigsbyId = async (id) => {
    const url = `${API_URL}/api/user-configs/${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const getuserconfigssuggestionsAccounts = async (id) => {
    const url = `${API_URL}/api/user-configs/suggestions/accounts`;
    return await JwtService.commanApi({}, url, "GET");
}

const setuserconfigs = async (data) => {
    const url = `${API_URL}/api/user-configs`;
    return await JwtService.commanApi(data, url, "POST");
}

const setuserconfigsTest = async (id) => {
    const url = `${API_URL}/api/user-configs/${id}/test`;
    return await JwtService.commanApi({}, url, "POST");
}

const deleteuserconfigs = async (id) => {
    const url = `${API_URL}/api/user-configs/${id}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const classificationssuggestionsType = async () => {
    const url = `${API_URL}/api/incident-classifications/suggestions/types`;
    return await JwtService.commanApi({}, url, "GET");
}

const classificationssuggestionsevents = async () => {
    const url = `${API_URL}/api/incident-classifications/suggestions/events`;
    return await JwtService.commanApi({}, url, "GET");
}

const updateincidentclassifications = async (id, data) => {
    const url = `${API_URL}/api/incident-classifications/${id}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const addincidentclassifications = async (data) => {
    const url = `${API_URL}/api/incident-classifications`;
    return await JwtService.commanApi(data, url, "POST");
}

const deleteincidentclassifications = async (id) => {
    const url = `${API_URL}/api/incident-classifications/${id}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const getactioncardsData = async () => {
    const url = `${API_URL}/api/action-cards`;
    return await JwtService.commanApi({}, url, "GET");
}

const deparincidentclassificationsrules = async () => {
    const url = `${API_URL}/api/incident-classifications/data/for-rules`;
    return await JwtService.commanApi({}, url, "GET");
}

const updateactioncards = async (id, data) => {
    const url = `${API_URL}/api/action-cards/${id}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const addactioncards = async (data) => {
    const url = `${API_URL}/api/action-cards`;
    return await JwtService.commanApi(data, url, "POST");
}

const deleteactioncards = async (id) => {
    const url = `${API_URL}/api/action-cards/${id}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const postactioncardstrigger = async (id) => {
    const url = `${API_URL}/api/action-cards/${id}/trigger`;
    return await JwtService.commanApi({}, url, "POST");
}

const updateTeamCrew = async (teamId, crewId, data) => {
    const url = `${API_URL}/api/teams/${teamId}/crews/${crewId}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const addTeamCrew = async (teamId, data) => {
    const url = `${API_URL}/api/teams/${teamId}/crews`;
    return await JwtService.commanApi(data, url, "POST");
}

const deleteTeamCrew = async (teamId, crewId) => {
    const url = `${API_URL}/api/teams/${teamId}/crews/${crewId}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

const getTeamsData = async () => {
    const url = `${API_URL}/api/teams`;
    return await JwtService.commanApi({}, url, "GET");
}

const getteamssuggestionsescalationstaff = async () => {
    const url = `${API_URL}/api/teams/suggestions/escalation-staff`;
    return await JwtService.commanApi({}, url, "GET");
}

const updateteams = async (id, data) => {
    const url = `${API_URL}/api/teams/${id}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const addteams = async (data) => {
    const url = `${API_URL}/api/teams`;
    return await JwtService.commanApi(data, url, "POST");
}

const deleteTeams = async (id) => {
    const url = `${API_URL}/api/teams/${id}`;
    return await JwtService.commanApi({}, url, "DELETE");
}

// Resources reference module (global catalog)
const getResourcesCatalog = async () => await JwtService.commanApi({}, `${API_URL}/api/resources`, "GET");
const addResourceCatalog = async (data) => await JwtService.commanApi(data, `${API_URL}/api/resources`, "POST");
const updateResourceCatalog = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/resources/${id}`, "PUT");
const deleteResourceCatalog = async (id) => await JwtService.commanApi({}, `${API_URL}/api/resources/${id}`, "DELETE");
const getIncidentResourceUsage = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/resource-usage`, "GET");
const recordIncidentResourceUsage = async (incidentId, resourceId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/resources/${resourceId}/usage`, "POST");

// API Connections module (external platform integrations)
const getApiConnections = async () => await JwtService.commanApi({}, `${API_URL}/api/api-connections`, "GET");
const addApiConnection = async (data) => await JwtService.commanApi(data, `${API_URL}/api/api-connections`, "POST");
const updateApiConnection = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/api-connections/${id}`, "PUT");
const deleteApiConnection = async (id) => await JwtService.commanApi({}, `${API_URL}/api/api-connections/${id}`, "DELETE");
const testApiConnection = async (id) => await JwtService.commanApi({}, `${API_URL}/api/api-connections/${id}/test`, "POST");
const fetchApiConnectionEvents = async (id) => await JwtService.commanApi({}, `${API_URL}/api/api-connections/${id}/fetch-events`, "POST");
const getExternalEventsWatch = async (refresh = false) => await JwtService.commanApi({}, `${API_URL}/api/api-connections/events/watch${refresh ? '?refresh=true' : ''}`, "GET");
const getEarlyWarningStatus = async () => await JwtService.commanApi({}, `${API_URL}/api/api-connections/early-warning-status`, "GET");
const pollExternalFeedsNow = async () => await JwtService.commanApi({}, `${API_URL}/api/api-connections/poll-now`, "POST");
const getIncidentWeather = async (id) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/weather`, "GET");
const getIncidentAssignedPersonnel = async (id) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/assigned-personnel`, "GET");
const getIncidentChannels = async (id) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/channels`, "GET");
const getIncidentChannelMessages = async (id, channelId, params = {}) => await JwtService.commanApi(params, `${API_URL}/api/incidents/${id}/channels/${encodeURIComponent(channelId)}/messages`, "GET");
const createIncidentChannel = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${id}/channels`, "POST");
const updateIncidentChannel = async (id, channelId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${id}/channels/${encodeURIComponent(channelId)}`, "PATCH");
const archiveIncidentChannel = async (id, channelId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/channels/${encodeURIComponent(channelId)}`, "DELETE");
const unlockIncidentChannel = async (id, channelId, passkey) => await JwtService.commanApi({ passkey }, `${API_URL}/api/incidents/${id}/channels/${encodeURIComponent(channelId)}/unlock`, "POST");
const confirmIncidentMapLocation = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${id}/map-location/confirm`, "POST");
const getOperationsArea = async () => await JwtService.commanApi({}, `${API_URL}/api/operations-area`, "GET");
const getOperationsAreaBoundary = async () => await JwtService.commanApi({}, `${API_URL}/api/operations-area/boundary`, "GET");
const getEarlyWarnings = async (limit = 100) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings?limit=${limit}`, "GET");
const dismissEarlyWarning = async (id) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/${id}`, "DELETE");
const getWarningCorroboration = async (id) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/${id}/corroboration`, "GET");
const getWarningDetail = async (id) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/${id}/detail`, "GET");
const getWarningTimeline = async (id) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/${id}/timeline`, "GET");
const assessWarning = async (id) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/${id}/assess`, "POST");
const getWarningAssessment = async (id) => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/${id}/assessment`, "GET");
const ackWarningAssessment = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/early-warnings/${id}/assessment/ack`, "POST");
const approveWarningDowngrade = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/early-warnings/${id}/assessment/approve-downgrade`, "POST");
const scenarioPrefillFromAssessment = async (data) => await JwtService.commanApi(data, `${API_URL}/api/scenario-builder/from-assessment`, "POST");
const scenarioPrefillFromWarning = async (data) => await JwtService.commanApi(data, `${API_URL}/api/scenario-builder/from-warning`, "POST");
const getAssets = async () => await JwtService.commanApi({}, `${API_URL}/api/assets`, "GET");
const getRiskConfig = async () => await JwtService.commanApi({}, `${API_URL}/api/foresight/risk-config`, "GET");
const updateRiskConfig = async (data) => await JwtService.commanApi(data, `${API_URL}/api/foresight/risk-config`, "PUT");
const previewRiskConfig = async (data) => await JwtService.commanApi(data, `${API_URL}/api/foresight/risk-config/preview`, "POST");
const getSignalCatalog = async () => await JwtService.commanApi({}, `${API_URL}/api/foresight/signal-catalog`, "GET");
const provisionEssentialForesightCoverage = async () => await JwtService.commanApi(
    {},
    `${API_URL}/api/foresight/coverage/essential/provision`,
    "POST"
);
const connectForesightProvider = async (providerKey, data = {}) => await JwtService.commanApi(
    data,
    `${API_URL}/api/foresight/providers/${encodeURIComponent(providerKey)}/connect`,
    "POST"
);
const upsertSourceProfile = async (originKey, data) => await JwtService.commanApi(data, `${API_URL}/api/foresight/source-profiles/${originKey}`, "PUT");
const verifyEvidence = async (warningId, intelId, data) => await JwtService.commanApi(data, `${API_URL}/api/early-warnings/${warningId}/evidence/${intelId}/verify`, "POST");
const getZoneRisk = async () => await JwtService.commanApi({}, `${API_URL}/api/foresight/zone-risk`, "GET");
const getForesightDecisionQueue = async () => await JwtService.commanApi({}, `${API_URL}/api/foresight/decision-queue`, "GET");
const createAsset = async (data) => await JwtService.commanApi(data, `${API_URL}/api/assets`, "POST");
const updateAsset = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/assets/${id}`, "PUT");
const deleteAsset = async (id) => await JwtService.commanApi({}, `${API_URL}/api/assets/${id}`, "DELETE");
const clearEarlyWarnings = async () => await JwtService.commanApi({}, `${API_URL}/api/early-warnings/clear`, "DELETE");
const dispatchEarlyWarning = async (data) => await JwtService.commanApi(data, `${API_URL}/api/early-warnings/dispatch`, "POST");
const probeSuggestionUrls = async (urls) => await JwtService.commanApi({ urls }, `${API_URL}/api/early-warnings/probe-urls`, "POST");
const getHazardScopes = async () => await JwtService.commanApi({}, `${API_URL}/api/operations-area/hazard-scopes`, "GET");
const getForesightPredictions = async () => await JwtService.commanApi({}, `${API_URL}/api/foresight/predictions`, "GET");
const getIotWatch = async () => await JwtService.commanApi({}, `${API_URL}/api/foresight/iot-watch`, "GET");
const setHazardScope = async (data) => await JwtService.commanApi(data, `${API_URL}/api/operations-area/hazard-scopes`, "PUT");
const discoverApisForHazard = async (hazard) => await JwtService.commanApi({ hazard }, `${API_URL}/api/early-warnings/discover-apis`, "POST");

const teamsTest = async (id) => {
    const url = `${API_URL}/api/teams/${id}/test`;
    return await JwtService.commanApi({}, url, "POST");
}

const getlocationsroots = async () => {
    const url = `${API_URL}/api/locations/roots`;
    return await JwtService.commanApi({}, url, "GET");
}

const getlocationschildren = async (id) => {
    const url = `${API_URL}/api/locations/${id}/children`;
    return await JwtService.commanApi({}, url, "GET");
}

const getanalyticsaiinsights = async () => {
    const url = `${API_URL}/api/analytics/ai-insights`;
    return await JwtService.commanApi({}, url, "GET");
}

const getanalyticsincidentstimeseries = async (id) => {
    const url = `${API_URL}/api/analytics/incidents/time-series?${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const checkduplicateincidentclassifications = async (name) => {
    const url = `${API_URL}/api/check-duplicate/incident-classifications/${encodeURIComponent(name)}`;
    return await JwtService.commanApi({}, url, "GET");
}

const checkduplicatedata = async (module, name, params) => {
    const url = `${API_URL}/api/check-duplicate/${module}/${encodeURIComponent(name.trim())}?${params}`;
    return await JwtService.commanApi({}, url, "GET");
}

const getincidentclassificationsbyId = async (id) => {
    const url = `${API_URL}/api/incident-classifications/${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const addincidents = async (data) => {
    const url = `${API_URL}/api/incidents`;
    return await JwtService.commanApi(data, url, "POST", true);
}

const exerciseTransition = async (id, data) => {
    const url = `${API_URL}/api/incidents/${id}/exercise/transition`;
    return await JwtService.commanApi(data, url, "POST");
}

const exerciseAutoSummary = async (id) => {
    const url = `${API_URL}/api/incidents/${id}/exercise/auto-summary`;
    return await JwtService.commanApi({}, url, "POST");
}

const incidentAutoSummary = async (id) => {
    const url = `${API_URL}/api/incidents/${encodeURIComponent(id)}/auto-summary`;
    return await JwtService.commanApi({}, url, "POST");
}

const analysisGenerate = async (data) => {
    const url = `${API_URL}/api/analysis/generate`;
    return await JwtService.commanApi(data, url, "POST");
}

const incidentAnalysisGenerate = async (id, data) => {
    const url = `${API_URL}/api/incidents/${encodeURIComponent(id)}/analysis/generate`;
    return await JwtService.commanApi(data, url, "POST");
}

const getIncidentAnalysisContext = async (id) => {
    const url = `${API_URL}/api/incidents/${encodeURIComponent(id)}/analysis/context`;
    return await JwtService.commanApi({}, url, "GET");
}

const getIncidentReview = async (id) => {
    const url = `${API_URL}/api/incidents/${encodeURIComponent(id)}/review`;
    return await JwtService.commanApi({}, url, "GET");
}

const saveIncidentReview = async (id, data) => {
    const url = `${API_URL}/api/incidents/${encodeURIComponent(id)}/review`;
    return await JwtService.commanApi(data, url, "PUT");
}

const runIncidentCopilot = async (id, data) => {
    const url = `${API_URL}/api/incidents/${encodeURIComponent(id)}/copilot`;
    return await JwtService.commanApi(data, url, "POST");
}

const discussionGroupInvite = async (id, entries) => {
    const url = `${API_URL}/api/incidents/${id}/discussion-group/invite`;
    return await JwtService.commanApi({ entries }, url, "POST");
}

const discussionGroupRemove = async (id, entries) => {
    const url = `${API_URL}/api/incidents/${id}/discussion-group/remove`;
    return await JwtService.commanApi({ entries }, url, "POST");
}

const discussionGroupUpdate = async (id, entry) => {
    const url = `${API_URL}/api/incidents/${id}/discussion-group/update`;
    return await JwtService.commanApi(entry, url, "POST");
}

const discussionGroupNotify = async (id, entry = null) => {
    const url = `${API_URL}/api/incidents/${id}/discussion-group/notify`;
    return await JwtService.commanApi(entry || {}, url, "POST");
}

const getRecommendedEntities = async (id) => {
    const url = `${API_URL}/api/incidents/${id}/recommended-entities`;
    return await JwtService.commanApi({}, url, "GET");
}

const getincidentclassificationtypes = async (id) => {
    const url = `${API_URL}/api/incident-classification/types/${id}?include=events,triggers&v=${timestamp}`;
    return await JwtService.commanApi({}, url, "GET");
}

const updatelocationsdepartmentsbyId = async (id, deptId, data) => {
    const url = `${API_URL}/api/locations/${id}/departments/${deptId}`;
    return await JwtService.commanApi(data, url, "PATCH");
}

const getIncidentReportData = async (id) => {
    const url = `${API_URL}/api/incident-reports/${id}`;
    return await JwtService.commanApi({}, url, "GET");
}

const getLoginDepartment = async () => {
    const url = `${API_URL}/api/get-department`;
    return await JwtService.commanApi({}, url, "GET");
}

const getSignupDepartments = async () => {
    const url = `${API_URL}/api/auth/signup-departments`;
    return await JwtService.commanApi({}, url, "GET", false, { publicRequest: true });
}

const teamsMatchedData = async (data) => {
    const url = `${API_URL}/api/teams/match`;
    return await JwtService.commanApi(data, url, "POST");
}

const updateIncidentTimeline = async (id, timeid, data) => {
    const url = `${API_URL}/api/incidents/${id}/timeline/${timeid}`;
    return await JwtService.commanApi(data, url, "PATCH");
}

/** Nudge a card's pending assignees now (real incidents only). */
const remindTimelineCard = async (id, timeid) => {
    const url = `${API_URL}/api/incidents/${id}/timeline/${timeid}/remind`;
    return await JwtService.commanApi({}, url, "POST");
}

const incidentTimelineUpsertReport = async (id, data) => {
    const url = `${API_URL}/api/incidents/${id}/timeline/upsert-report`;
    return await JwtService.commanApi(data, url, "POST");
}

const addincidentTimeline = async (id, data) => {
    const url = `${API_URL}/api/incidents/${id}/timeline`;
    const res = await JwtService.commanApi(data, url, "POST");
    // Announce the new card so the open incident page can scroll to and
    // highlight it (see IncidentTimeline's 'timelineCardCreated' listener).
    // This endpoint returns the raw TimelineItem (no send_success wrapper),
    // but tolerate both shapes.
    try {
        const created = [res, res?.data, res?.data?.data]
            .find((candidate) => candidate && (candidate.id || candidate._id));
        const itemId = created?.id || created?._id;
        if (
            itemId
            && res?.status !== false
            && res?.success !== false
            && res?.data?.status !== false
            && res?.data?.success !== false
            && res?.data?.data?.status !== false
            && res?.data?.data?.success !== false
        ) {
            window.dispatchEvent(new CustomEvent('timelineCardCreated', {
                detail: { incidentId: id, itemId, group: created?.group || data?.group || null },
            }));
        }
    } catch (_) { /* announcement is best-effort */ }
    return res;
}

const updatePutIncidentTimeline = async (id, timeid, data) => {
    const url = `${API_URL}/api/incidents/${id}/timeline/${timeid}`;
    return await JwtService.commanApi(data, url, "PUT");
}

const getAppUsers = async () => {
    const url = `${API_URL}/api/app-users`;
    return await JwtService.commanApi({}, url, "GET");
}

const getIncidentRecipientDirectory = async (incidentId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/recipient-directory`;
    return await JwtService.commanApi({}, url, "GET");
}

export const normalizeIncidentRecipientDirectory = (response) => {
    const payload = response?.data && !Array.isArray(response.data) ? response.data : (response || {});
    const users = Array.isArray(payload.users) ? payload.users : [];
    const departments = Array.isArray(payload.departments) ? payload.departments : [];
    const teams = Array.isArray(payload.teams) ? payload.teams : [];
    const explicitCrews = Array.isArray(payload.crews) ? payload.crews : [];
    const crews = explicitCrews.length ? explicitCrews.map((crew) => {
        const team = teams.find((row) => String(row.id || row._id || '') === String(crew.team_id || crew.teamId || ''));
        return {
            ...crew,
            team_id: crew.team_id || crew.teamId || team?.id || team?._id,
            team_name: crew.team_name || team?.team_name || team?.name,
        };
    }) : teams.flatMap((team) => (
        (team.crews || []).map((crew) => ({
            ...crew,
            team_id: crew.team_id || team.id || team._id,
            team_name: crew.team_name || team.team_name || team.name,
        }))
    ));
    const teamsWithCrews = teams.map((team) => {
        const existing = Array.isArray(team.crews) ? team.crews : [];
        if (existing.length) return team;
        const teamId = String(team.id || team._id || '');
        return { ...team, crews: crews.filter((crew) => String(crew.team_id || '') === teamId) };
    });
    const cleanIds = (value) => Array.isArray(value) ? value.map(String) : [];
    const rawDuty = payload.duty?.users ?? payload.duty;
    const duty = Array.isArray(rawDuty)
        ? Object.fromEntries(rawDuty.filter((entry) => entry?.user_id || entry?.id).map((entry) => [String(entry.user_id || entry.id), entry]))
        : (rawDuty && typeof rawDuty === 'object' ? rawDuty : {});
    return {
        users,
        departments,
        teams: teamsWithCrews,
        crews,
        duty,
        allowedUserIds: cleanIds(payload.allowed_user_ids ?? payload.allowedUserIds),
        allowedDepartmentIds: cleanIds(payload.allowed_department_ids ?? payload.allowedDepartmentIds),
        allowedTeamIds: cleanIds(payload.allowed_team_ids ?? payload.allowedTeamIds),
        allowedCrewIds: cleanIds(payload.allowed_crew_ids ?? payload.allowedCrewIds),
        involvedUserIds: cleanIds(payload.involved_user_ids ?? payload.involvedUserIds),
    };
};

const getOnlineUsers = async (incidentId = null) => {
    const query = incidentId ? `?incident_id=${encodeURIComponent(String(incidentId))}` : '';
    const url = `${API_URL}/api/presence/online-users${query}`;
    return await JwtService.commanApi({}, url, "GET");
}

const notificationMaunal = async (id, data) => {
    const url = `${API_URL}/api/incidents/${id}/notifications/manual`;
    const res = await JwtService.commanApi(data, url, "POST");
    // Manual notifications create their timeline card server-side; announce it
    // so the incident page scrolls to and highlights the new card.
    try {
        const itemId = res?.timeline_item_id || res?.data?.timeline_item_id || res?.data?.data?.timeline_item_id;
        if (
            itemId
            && res?.status !== false
            && res?.success !== false
            && res?.data?.status !== false
            && res?.data?.success !== false
            && res?.data?.data?.status !== false
            && res?.data?.data?.success !== false
        ) {
            window.dispatchEvent(new CustomEvent('timelineCardCreated', {
                detail: { incidentId: id, itemId, group: 'notification' },
            }));
        }
    } catch (_) { /* best-effort */ }
    return res;
}

const updatePatchIncidents = async (id, data) => {
    const url = `${API_URL}/api/incidents/${id}`;
    return await JwtService.commanApi(data, url, "PATCH");
}

const getincidentsFamily = async (id) => {
    const url = `${API_URL}/api/incidents/${id}/family?t=${Date.now()}`;
    return await JwtService.commanApi({}, url, "GET");
}

const getAiDescription = async (data) => {
    const url = `${API_URL}/api/ai/incident/getdescription`;
    return await JwtService.commanApi(data, url, "POST");
}

const deleteLocationZonesAttachment = async (data) => {
    const url = `${API_URL}/api/locations/zones/attachments`;
    return await JwtService.commanApi(data, url, "POST");
}

const getAnalyzeImageWithAI = async (data) => {
    const url = `${API_URL}/api/ai/image-classify`;
    return await JwtService.commanApi(data, url, "POST", true);
}

const addChatHistory = async (data) => {
    const url = `${API_URL}/api/chat/history`;
    return await JwtService.commanApi(data, url, "POST");
};


const sendDutyCheck = async (payload = {}) => {
    const url = `${API_URL}/api/duty-check/send`;
    return await JwtService.commanApi(payload, url, "POST");
};

const getDutyCheckResponses = async (checkId) => {
    const url = `${API_URL}/api/duty-check/responses/${checkId}`;
    return await JwtService.commanApi({}, url, "GET");
};

const getLatestDutyCheck = async () => {
    const url = `${API_URL}/api/duty-check/latest`;
    return await JwtService.commanApi({}, url, "GET");
};

const getDutyCheckHistory = async ({ limit = 50, skip = 0, q } = {}) => {
    const params = new URLSearchParams();
    params.set("limit", String(limit));
    params.set("skip", String(skip));
    if (q) params.set("q", q);
    const url = `${API_URL}/api/duty-check/history?${params.toString()}`;
    return await JwtService.commanApi({}, url, "GET");
};

const getDutyCheckById = async (checkId) => {
    const url = `${API_URL}/api/duty-check/${checkId}`;
    return await JwtService.commanApi({}, url, "GET");
};

const saveIncidentPreconfiguration = async (incidentId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/preconfiguration/save`;
    return await JwtService.commanApi({}, url, "POST");
};

const stopIncidentAlarm = async (incidentId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/alarm/stop`;
    return await JwtService.commanApi({}, url, "POST");
};

const getAiChatResponse = async (data) => {
    const url = `${API_URL}/api/ai/chat`;
    return await JwtService.commanApi(data, url, "POST");
};

const aiCreateClassification = async (data) => {
    const url = `${API_URL}/api/incident-classifications/ai-create`;
    return await JwtService.commanApi(data, url, "POST");
};

const deleteTimelineItem = async (incidentId, itemId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/timeline/${itemId}`;
    return await JwtService.commanApi({}, url, "DELETE");
};

const getTeamLocations = async (incidentId = null) => {
    const query = incidentId ? `?incident_id=${encodeURIComponent(incidentId)}` : '';
    const url = `${ApiEndPoint}/api/teams/locations${query}`;
    return await JwtService.commanApi({}, url, "GET");
};

const updateTeamLocation = async (data) => {
    const url = `${ApiEndPoint}/api/teams/location`;
    return await JwtService.commanApi(data, url, "POST");
};

const updateTeamLocationAdmin = async (data) => {
    const url = `${ApiEndPoint}/api/teams/location/admin`;
    return await JwtService.commanApi(data, url, "POST");
};
const getActiveCalls = async () => {
    const url = `${API_URL}/api/calls/active`;
    return await JwtService.commanApi({}, url, "GET");
}

const uploadGenericFile = async (data, key = 'incident_classification') => {
    const url = `${API_URL}/api/upload/${key}`;
    return await JwtService.commanApi(data, url, "POST", true);
}

const getTimelineComments = async (incidentId, itemId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/timeline/${itemId}/comments`;
    return await JwtService.commanApi({}, url, "GET");
}

const addTimelineComment = async (incidentId, itemId, data) => {
    const url = `${API_URL}/api/incidents/${incidentId}/timeline/${itemId}/comments`;
    return await JwtService.commanApi(data, url, "POST");
}

const toggleTimelineApproval = async (incidentId, itemId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/timeline/${itemId}/approve`;
    return await JwtService.commanApi({}, url, "POST");
}

const getIncidentActivityFeed = async (incidentId, mode = '', scope = '') => {
    const query = new URLSearchParams();
    if (mode) query.set('mode', mode);
    if (scope) query.set('scope', scope);
    const queryString = query.toString();
    const url = `${API_URL}/api/incidents/${incidentId}/activity-feed${queryString ? `?${queryString}` : ''}`;
    return await JwtService.commanApi({}, url, "GET");
}

const getIncidentAuditLog = async (incidentId) => {
    const url = `${API_URL}/api/incidents/${incidentId}/audit-log`;
    return await JwtService.commanApi({}, url, "GET");
}

const addIncidentAuditLog = async (incidentId, data) => {
    const url = `${API_URL}/api/incidents/${incidentId}/audit-log`;
    return await JwtService.commanApi(data, url, "POST");
}

const createScenario = async (data) => await JwtService.commanApi(data, `${API_URL}/api/scenarios`, "POST");
const listScenarios = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/scenarios${query ? `?${query}` : ''}`, "GET");
const getScenarioStats = async () => await JwtService.commanApi({}, `${API_URL}/api/scenarios/stats`, "GET");
const getScenarioUsage = async (scenarioId) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/${scenarioId}/usage`, "GET");
const getScenario = async (id) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/${id}`, "GET");
const updateScenario = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/scenarios/${id}`, "PATCH");
const duplicateScenario = async (id) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/${id}/duplicate`, "POST");
const archiveScenario = async (id) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/${id}/archive`, "POST");
const deleteScenario = async (id) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/${id}`, "DELETE");
const syncScenario = async (id) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/${id}/sync`, "POST");
const matchScenario = async (params) => await JwtService.commanApi({}, `${API_URL}/api/scenarios/match?${new URLSearchParams(params).toString()}`, "GET");
const launchScenario = async (id, body = {}) => await JwtService.commanApi(body, `${API_URL}/api/scenarios/${id}/launch`, "POST");
const scenarioBuilderChat = async (data) => await JwtService.commanApi(data, `${API_URL}/api/scenario-builder/chat`, "POST");
const getScenarioDrift = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/scenario-drift`, "GET");
const saveScenarioStaffingDefaults = async (scenarioId, data) => await JwtService.commanApi(data, `${API_URL}/api/scenarios/${scenarioId}/staffing-defaults`, "PUT");
const saveIncidentStaffingPlan = async (incidentId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/staffing-plan`, "PUT");
const getIncidentStaffingReview = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/staffing-review`, "GET");
const acceptIncidentStaffing = async (incidentId, data = {}) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/staffing/accept`, "POST");
const sendIncidentReadinessCheck = async (incidentId, expiryMinutes = 5) => await JwtService.commanApi({ expiry_minutes: expiryMinutes }, `${API_URL}/api/incidents/${incidentId}/readiness-check`, "POST");
const getIncidentReadinessCheck = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/readiness-check/latest`, "GET");
const getIncidentReadinessHistory = async (incidentId, { limit = 50, skip = 0 } = {}) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/readiness-check/history?limit=${limit}&skip=${skip}`, "GET");
const cancelIncidentAutoActivation = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/cancel-auto-activation`, "POST");
// GIS map persistence — saves map drawings to a scenario/drill's backing incident
const getIncidentGisMap = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/gis-map?t=${Date.now()}`, "GET");
const saveIncidentGisMap = async (incidentId, gisMap) => await JwtService.commanApi({ gis_map: gisMap }, `${API_URL}/api/incidents/${incidentId}/gis-map`, "PUT");
const saveExerciseAsScenario = async (incidentId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/save-as-scenario`, "POST");
const toggleExercisePause = async (id) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/exercise/pause`, "POST");
const fireInjectNow = async (id, itemId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/exercise/fire/${itemId}`, "POST");
const getExerciseLog = async (id) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${id}/exercise/log`, "GET");
// Strategic Partners — secure collaboration pages
const partnerPagesList = async () => await JwtService.commanApi({}, `${API_URL}/api/partner-pages`, "GET");
const partnerPageCreate = async (data) => await JwtService.commanApi(data, `${API_URL}/api/partner-pages`, "POST");
const partnerPageDelete = async (id) => await JwtService.commanApi({}, `${API_URL}/api/partner-pages/${id}`, "DELETE");
const partnerMessagesList = async (id) => await JwtService.commanApi({}, `${API_URL}/api/partner-pages/${id}/messages`, "GET");
const partnerMessageSend = async (id, data) => await JwtService.commanApi(data, `${API_URL}/api/partner-pages/${id}/messages`, "POST");
// Corrective Actions & Observations (AAR)
const createObservation = async (incidentId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/observations`, "POST");
const listObservations = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/observations`, "GET");
const deleteObservation = async (obsId) => await JwtService.commanApi({}, `${API_URL}/api/observations/${obsId}`, "DELETE");
const listIncidentComments = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/all-comments`, "GET");
const createCorrectiveAction = async (incidentId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/corrective-actions`, "POST");
const listIncidentCorrectiveActions = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/incidents/${incidentId}/corrective-actions`, "GET");
const listCorrectiveActions = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/corrective-actions${query ? `?${query}` : ''}`, "GET");
const updateCorrectiveAction = async (caId, data) => await JwtService.commanApi(data, `${API_URL}/api/corrective-actions/${caId}`, "PATCH");
const deleteCorrectiveAction = async (caId) => await JwtService.commanApi({}, `${API_URL}/api/corrective-actions/${caId}`, "DELETE");
// Reports Center (server-side, full-collection aggregation)
const getReportsSummary = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/summary${query ? `?${query}` : ''}`, "GET");
const getReportsAcknowledgments = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/acknowledgments${query ? `?${query}` : ''}`, "GET");
const getReportsAuditLog = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/audit-log${query ? `?${query}` : ''}`, "GET");
const getReportsPerformance = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/performance${query ? `?${query}` : ''}`, "GET");
const getReportsAdherence = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/adherence${query ? `?${query}` : ''}`, "GET");
const getReportsBenchmarks = async () => await JwtService.commanApi({}, `${API_URL}/api/reports/benchmarks`, "GET");
const saveReportsBenchmarks = async (data) => await JwtService.commanApi(data, `${API_URL}/api/reports/benchmarks`, "PUT");
const getReportsSchedule = async () => await JwtService.commanApi({}, `${API_URL}/api/reports/schedule`, "GET");
const saveReportsSchedule = async (data) => await JwtService.commanApi(data, `${API_URL}/api/reports/schedule`, "PUT");
const getReportsProgram = async () => await JwtService.commanApi({}, `${API_URL}/api/reports/program`, "GET");
const getReportsRegister = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/register${query ? `?${query}` : ''}`, "GET");
const getReportsOperations = async (query = '') => await JwtService.commanApi({}, `${API_URL}/api/reports/operations${query ? `?${query}` : ''}`, "GET");
const queryReportsAssistant = async (data) => await JwtService.commanApi(data, `${API_URL}/api/reports/assistant/query`, "POST");
const listReportsAssistantConversations = async () => await JwtService.commanApi({}, `${API_URL}/api/reports/assistant/conversations`, "GET");
const createReportsAssistantConversation = async (data = {}) => await JwtService.commanApi(data, `${API_URL}/api/reports/assistant/conversations`, "POST");
const getReportsAssistantConversation = async (conversationId) => await JwtService.commanApi({}, `${API_URL}/api/reports/assistant/conversations/${encodeURIComponent(conversationId)}`, "GET");
const updateReportsAssistantConversation = async (conversationId, data) => await JwtService.commanApi(data, `${API_URL}/api/reports/assistant/conversations/${encodeURIComponent(conversationId)}`, "PATCH");
const deleteReportsAssistantConversation = async (conversationId) => await JwtService.commanApi({}, `${API_URL}/api/reports/assistant/conversations/${encodeURIComponent(conversationId)}`, "DELETE");
const getIncidentComms = async (incidentId) => await JwtService.commanApi({}, `${API_URL}/api/reports/incidents/${incidentId}/comms`, "GET");
const scoreIncidentObjective = async (incidentId, data) => await JwtService.commanApi(data, `${API_URL}/api/incidents/${incidentId}/objective-score`, "POST");

export const CommanServices = {
    getActiveCalls,
    getTeamLocations,
    updateTeamLocation,
    updateTeamLocationAdmin,
    deleteTimelineItem,
    getAiChatResponse,
    aiCreateClassification,
    addChatHistory,
    getAnalyzeImageWithAI,
    deleteLocationZonesAttachment,
    getAiDescription,
    checkduplicatedata,
    getincidentsFamily,
    updatePatchIncidents,
    notificationMaunal,
    getAppUsers,
    getIncidentRecipientDirectory,
    getOnlineUsers,
    updatePutIncidentTimeline,
    incidentTimelineUpsertReport,
    addincidentTimeline,
    updateIncidentTimeline,
    remindTimelineCard,
    teamsMatchedData,
    getLoginDepartment,
    getSignupDepartments,
    updatelocationsdepartmentsbyId,
    getincidentclassificationtypes,
    addincidents,
    exerciseTransition,
    exerciseAutoSummary,
    incidentAutoSummary,
    analysisGenerate,
    incidentAnalysisGenerate,
    getIncidentAnalysisContext,
    getIncidentReview,
    saveIncidentReview,
    runIncidentCopilot,
    discussionGroupInvite,
    discussionGroupRemove,
    discussionGroupUpdate,
    discussionGroupNotify,
    getRecommendedEntities,
    getincidentclassificationsbyId,
    checkduplicateincidentclassifications,
    getanalyticsincidentstimeseries,
    getanalyticsaiinsights,
    getlocationschildren,
    getlocationsroots,
    teamsTest,
    deleteTeams,
    getResourcesCatalog,
    addResourceCatalog,
    updateResourceCatalog,
    deleteResourceCatalog,
    getIncidentResourceUsage,
    recordIncidentResourceUsage,
    getApiConnections,
    addApiConnection,
    updateApiConnection,
    deleteApiConnection,
    testApiConnection,
    fetchApiConnectionEvents,
    getExternalEventsWatch,
    getEarlyWarningStatus,
    pollExternalFeedsNow,
    getIncidentWeather,
    getIncidentAssignedPersonnel,
    getIncidentChannels,
    getIncidentChannelMessages,
    createIncidentChannel,
    updateIncidentChannel,
    archiveIncidentChannel,
    unlockIncidentChannel,
    confirmIncidentMapLocation,
    getOperationsArea,
    getOperationsAreaBoundary,
    getEarlyWarnings,
    getWarningCorroboration,
    getWarningDetail,
    getWarningTimeline,
    assessWarning,
    getWarningAssessment,
    ackWarningAssessment,
    approveWarningDowngrade,
    scenarioPrefillFromAssessment,
    scenarioPrefillFromWarning,
    getAssets,
    getRiskConfig,
    updateRiskConfig,
    previewRiskConfig,
    getSignalCatalog,
    provisionEssentialForesightCoverage,
    connectForesightProvider,
    upsertSourceProfile,
    verifyEvidence,
    getZoneRisk,
    getForesightDecisionQueue,
    createAsset,
    updateAsset,
    deleteAsset,
    dismissEarlyWarning,
    clearEarlyWarnings,
    dispatchEarlyWarning,
    probeSuggestionUrls,
    discoverApisForHazard,
    getHazardScopes,
    setHazardScope,
    getForesightPredictions,
    getIotWatch,
    addteams,
    updateteams,
    getteamssuggestionsescalationstaff,
    getTeamsData,
    updateTeamCrew,
    addTeamCrew,
    deleteTeamCrew,
    postactioncardstrigger,
    deleteactioncards,
    updateactioncards,
    addactioncards,
    deparincidentclassificationsrules,
    getactioncardsData,
    deleteincidentclassifications,
    updateincidentclassifications,
    addincidentclassifications,
    classificationssuggestionsType,
    classificationssuggestionsevents,
    deleteuserconfigs,
    setuserconfigsTest,
    setuserconfigs,
    getuserconfigssuggestionsAccounts,
    getuserconfigsbyId,
    getlocationszonesdata,
    getdepartmentslocation,
    deletebyIddepartments,
    adddepartments,
    updateuserconfigs,
    getuserconfigs,
    getdepartmentssuggestionsmembers,
    updatelocationszones,
    locationszonesChipId,
    locationshierarchyByid,
    updatedepartments,
    getbyIddepartments,
    deleteDepartmentToLocation,
    addDepartmentToLocation,
    updatelocationshierarchy,
    setlocationshierarchy,
    deletelocationssuggestionsfloors,
    deletelocationssuggestionscorridors,
    deletelocationssuggestionsrooms,
    deletelocationssuggestionsbuildings,
    deletelocationssuggestionszonetypes,
    locationssuggestionsfloors,
    locationssuggestionscorridors,
    locationssuggestionsrooms,
    locationssuggestionsbuildings,
    locationssuggestionszonenames,
    locationssuggestionszonetypes,
    getLocationDepartmentCounts,
    signup,
    login,
    forgotPassword,
    getMe,
    updateProfile,
    changePassword,
    impersonateUser,
    setToken,
    getToken,
    logout,
    fetchIncidents,
    getNotifications,
    postIncidentHistory,
    getIncidentHistory,
    deleteIncidentHistory,
    getincidentTimeline,
    getIncidentPlanAdherence,
    imagePreview,
    getIncidentsData,
    incidentClassifications,
    departments,
    departmentslocationcounts,
    getIncidentDetail,
    locationsType,
    locationsValue,
    deleteLocationZones,
    locationszoneswithlinks,
    getIncidentReportData,
    sendDutyCheck,
    getDutyCheckResponses,
    getLatestDutyCheck,
    getDutyCheckHistory,
    getDutyCheckById,
    saveIncidentPreconfiguration,
    stopIncidentAlarm,
    uploadGenericFile,
    getTimelineComments,
    addTimelineComment,
    toggleTimelineApproval,
    getIncidentActivityFeed,
    getIncidentAuditLog,
    addIncidentAuditLog,
    createScenario,
    listScenarios,
    getScenarioStats,
    getScenarioUsage,
    getScenario,
    updateScenario,
    duplicateScenario,
    archiveScenario,
    deleteScenario,
    syncScenario,
    matchScenario,
    launchScenario,
    scenarioBuilderChat,
    getScenarioDrift,
    saveScenarioStaffingDefaults,
    saveIncidentStaffingPlan,
    getIncidentStaffingReview,
    acceptIncidentStaffing,
    sendIncidentReadinessCheck,
    getIncidentReadinessCheck,
    getIncidentReadinessHistory,
    cancelIncidentAutoActivation,
    getIncidentGisMap,
    saveIncidentGisMap,
    saveExerciseAsScenario,
    toggleExercisePause,
    fireInjectNow,
    getExerciseLog,
    partnerPagesList,
    partnerPageCreate,
    partnerPageDelete,
    partnerMessagesList,
    partnerMessageSend,
    createObservation,
    listObservations,
    deleteObservation,
    listIncidentComments,
    createCorrectiveAction,
    listIncidentCorrectiveActions,
    listCorrectiveActions,
    updateCorrectiveAction,
    deleteCorrectiveAction,
    getReportsSummary,
    getReportsAcknowledgments,
    getReportsAuditLog,
    getReportsPerformance,
    getReportsAdherence,
    getReportsBenchmarks,
    saveReportsBenchmarks,
    getReportsSchedule,
    saveReportsSchedule,
    getReportsProgram,
    getReportsRegister,
    getReportsOperations,
    queryReportsAssistant,
    listReportsAssistantConversations,
    createReportsAssistantConversation,
    getReportsAssistantConversation,
    updateReportsAssistantConversation,
    deleteReportsAssistantConversation,
    getIncidentComms,
    scoreIncidentObjective,
};
